import { render, staticRenderFns } from "./profileComponent.vue?vue&type=template&id=de4c58ba&lang=pug&"
import script from "./profileComponent.vue?vue&type=script&lang=js&"
export * from "./profileComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports